import { Card, CardBody, Col } from "reactstrap";
import { DropdownOptionsTitle } from "../../../../Constants/Constants";
import { DropdownOptionsSubTitle } from "../../../../Data/UiKits/Dropdown";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import Offset from "./Offset";
import Reference from "./Reference";

const DropdownOptions = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={DropdownOptionsTitle} span={DropdownOptionsSubTitle} />
        <CardBody>
          <div className="common-flex dropdown-option">
            <Offset />
            <Reference />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DropdownOptions;
